import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-experience',
  templateUrl: './experience.component.html',
  styleUrls: ['./experience.component.scss']
})
export class ExperienceComponent implements OnInit {
  infoMessage: any;
  isUploading: boolean = false;
  file: File;
  imgs = [];
  imageUrl: string | ArrayBuffer = "./assets/img/screen/cover.png";
  fileName: string = "No file selected";
  constructor() { }
  cnt = 0;
  ngOnInit(): void {
    for (let i = 0; i < 5; i++) {
      this.imgs[i] = this.imageUrl;
    }
  }

  onChange(file: File) {

    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
        this.imgs[this.cnt] = this.imageUrl;
        this.cnt++;
      };
     
    }
  }
}
